import { Setting } from '../../Settings/types/Setting';

export const getStoreSettingValue = (storeSettings: Setting[] | undefined, key: string) =>
    storeSettings?.find(s => s.settingKeyType === key)?.value ?? '';
const SettingsHelpers = { getStoreSettingValue };
export default SettingsHelpers;
